import { create } from "@/lib/zustand";
import { AgentStatus } from "@/models/agent/agentStatus";

interface AgentThreadState {
  isOpenToolPanel: boolean;
  isOpenFileBrowser: boolean;
  latestAgentStatus: AgentStatus | null;
  selectedToolCallMessageId: string | null;
  hasScrollSpacer: boolean;
  setIsOpenToolPanel: (isOpen: boolean) => void;
  setIsOpenFileBrowser: (isOpen: boolean) => void;
  setLatestAgentStatus: (status: AgentStatus | null) => void;
  setHasScrollSpacer: (has: boolean) => void;
  openToolPanel: (toolCallMessageId: string) => void;
  closeToolPanel: () => void;
}

const useAgentThreadStore = create<AgentThreadState>()((set) => ({
  isOpenToolPanel: false,
  isOpenFileBrowser: false,
  latestAgentStatus: null,
  selectedToolCallMessageId: null,
  hasScrollSpacer: false,
  setIsOpenToolPanel: (isOpen) => set({ isOpenToolPanel: isOpen }),
  setIsOpenFileBrowser: (isOpen) => set({ isOpenFileBrowser: isOpen }),
  setLatestAgentStatus: (status) => set({ latestAgentStatus: status }),
  setHasScrollSpacer: (has) => set({ hasScrollSpacer: has }),
  openToolPanel: (toolCallMessageId) =>
    set({
      isOpenToolPanel: true,
      selectedToolCallMessageId: toolCallMessageId,
    }),
  closeToolPanel: () =>
    set({
      isOpenToolPanel: false,
      selectedToolCallMessageId: null,
    }),
}));

let currentThreadId: string | undefined = undefined;

export const getAgentThreadStore = (threadId: string | undefined) => {
  if (currentThreadId !== threadId) {
    currentThreadId = threadId;
    useAgentThreadStore.setState(useAgentThreadStore.getInitialState(), true);
  }
  return useAgentThreadStore;
};
